/**
 * Parse a Knowtex note into a mapping of note_field -> section content.
 * Section headers in the note are in ALL CAPS followed by a colon (e.g., "CHIEF COMPLAINT:").
 * The noteFields array contains the desired output keys (e.g., ["Chief Complaint Show", ...])
 * This function will normalize field names and map them to the corresponding section content.
 *
 * @param {string} note - The full note text.
 * @param {string[]} noteFields - The list of field names from the mapping (e.g., ["Chief Complaint Show", ...])
 * @returns {Object} - Mapping of note_field to section text.
 */
function parseNoteToFields(note, noteFields) {
  // Step 1: Parse the note into sections using ALL CAPS headers
  const sectionRegex = /^([A-Z0-9 &/']+):$/gm;
  let match;
  let lastIndex = 0;
  let lastSection = null;
  const sections = {};
  const sectionOrder = [];

  // Find all section headers and their positions
  while ((match = sectionRegex.exec(note)) !== null) {
    if (lastSection) {
      // Previous section content is from lastIndex to match.index
      sections[lastSection] = note.slice(lastIndex, match.index).trim();
    }
    lastSection = match[1].trim();
    sectionOrder.push(lastSection);
    lastIndex = sectionRegex.lastIndex;
  }
  // Add last section
  if (lastSection) {
    sections[lastSection] = note.slice(lastIndex).trim();
  }

  // Step 2: Map noteFields to parsed sections
  const result = {};
  for (const field of noteFields) {
    // Normalize field to match section header (e.g., "Chief Complaint Show" -> "CHIEF COMPLAINT")
    let normalized = field.replace(/ Show$/, '').toUpperCase();
    if (sections[normalized]) {
      result[field] = sections[normalized];
    } else {
      result[field] = ""; // Or null, or omit if preferred
    }
  }
  return result;
}

export default parseNoteToFields;
